"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "casina": {
    "f2922af2": [{
      "hkey": "a9bb5604",
      "slug": "giandeto-straduzzi",
      "name": "Giandeto Straduzzi",
      "primary": true,
      "skipSearch": false
    }],
    "giandeto": [{
      "hkey": "a9bb5604",
      "slug": "giandeto-straduzzi",
      "name": "Giandeto Straduzzi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e0525b41": [{
      "hkey": "8b21673b",
      "slug": "migliara-boastra",
      "name": "Migliara-Boastra",
      "primary": true,
      "skipSearch": false
    }],
    "migliara": [{
      "hkey": "8b21673b",
      "slug": "migliara-boastra",
      "name": "Migliara-Boastra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "eeb90946": [{
      "hkey": "644e8df5",
      "slug": "paullo-costaferrata-crocicchio",
      "name": "Paullo-Costaferrata-Crocicchio",
      "primary": true,
      "skipSearch": false
    }],
    "paullo": [{
      "hkey": "644e8df5",
      "slug": "paullo-costaferrata-crocicchio",
      "name": "Paullo-Costaferrata-Crocicchio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bacb4ace": [{
      "hkey": "21f2a337",
      "slug": "casina",
      "name": "Casina",
      "primary": true,
      "skipSearch": false
    }],
    "pianzo": [{
      "hkey": "21f2a337",
      "slug": "casina",
      "name": "Casina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e5082981": [{
      "hkey": "709a6770",
      "slug": "casina",
      "name": "Casina",
      "primary": true,
      "skipSearch": false
    }],
    "sarzano-casina": [{
      "hkey": "709a6770",
      "slug": "casina",
      "name": "Casina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;